import { default as NextImage } from 'next/legacy/image';
import { NotificationType } from '.';

export const getIconByNotificationType = (
  notificationType: NotificationType
) => {
  return (
    <NextImage
      src={`/images/icons/${notificationType}.svg`}
      alt="Invisalign"
      height={20}
      width={20}
    />
  );
};
